/* eslint-disable */
var apiroot = 'https://api.gokaizen.com';
if (window.location.hostname.includes('kztesting.com')) {
  // Use staging API in testing site
  apiroot = 'https://kz-staging-api-asia-east1-qpkgja3rxa-de.a.run.app';
}
if (window.location.hostname == 'localhost' && window.webpackHotUpdate) {
  // Use staging API when testing locally
  apiroot = 'https://kz-staging-api-asia-east1-qpkgja3rxa-de.a.run.app';
  // Uncomment below to test API locally
  // apiroot = 'http://localhost:8080';
}

function getHeaders() {
  const headers = {};
  if (localStorage.refresh_token) {
    headers.Authorization = `Bearer ${localStorage.refresh_token}`;
  }
  headers['Content-Type'] = 'application/json';
  headers['Accept-Language'] = localStorage.language || 'en';
  if (localStorage.accessId) {
    headers['Access-ID'] = localStorage.accessId;
  }
  return headers;
}

function handleResponse(resp) {
  if (resp.status == 200) {
    return resp.json();
  }

  return resp.json().then((body) => Promise.reject(body));
}

function handleGet(path, qs) {
  const url = new URL(apiroot + path);
  qs = qs || {};
  Object.keys(qs).forEach((key) => {
    qs[key] && url.searchParams.append(key, qs[key]);
  });
  return fetch(url, {
    method: 'GET',
    cors: 'cors',
    headers: getHeaders(),
  }).then(handleResponse);
}

function handlePost(path, body) {
  const url = new URL(apiroot + path);
  return fetch(url, {
    method: 'POST',
    cors: 'cors',
    headers: getHeaders(),
    body: JSON.stringify(body),
  }).then(handleResponse);
}

function handlePut(path, body) {
  const url = new URL(apiroot + path);
  return fetch(url, {
    method: 'PUT',
    cors: 'cors',
    headers: getHeaders(),
    body: JSON.stringify(body),
  }).then(handleResponse);
}

function handleDelete(path) {
  const url = new URL(apiroot + path);
  return fetch(url, {
    method: 'DELETE',
    cors: 'cors',
    headers: getHeaders(),
  }).then(handleResponse);
}

export default {
  get: handleGet,
  post: handlePost,
  put: handlePut,
  delete: handleDelete,
};
